import React from 'react';
import { useCurrencyIcon } from '../../Contexts/CurrenciesContext';
export const CurrencyIcon = ({ a3, diameter = 24, }) => {
    const icon = useCurrencyIcon(a3);
    return <img width={diameter} height={diameter} src={icon}/>;
};
